module.exports = __webpack_public_path__ + "media/images/shapes/waves/wave-1-f940055af9f4d675f927399e70e20f0f.svg";